import { Controller } from "@hotwired/stimulus"

// Mirrors a switch checkbox to a collapsible page section's open state, so the
// section's stock header-click toggle also flips the switch. `halt` goes on the
// checkbox itself: a click on the switch label already bubbles to the header
// toggle once, so the label's synthetic click on the checkbox must not bubble
// there a second time.
export default class extends Controller {
  static targets = ["checkbox"]

  halt(event) {
    event.stopPropagation()
  }

  syncFromCheckbox() {
    const section = this.element.querySelector("[data-toggle-open-open-value]")
    const open = section.dataset.toggleOpenOpenValue === "true"

    if (this.checkboxTarget.checked !== open) {
      section.querySelector("header").click()
    }
  }

  sync(event) {
    if (event.target.closest("label")) return

    const open = this.element.querySelector("[data-toggle-open-open-value]")
    this.checkboxTarget.checked = open.dataset.toggleOpenOpenValue === "true"
  }
}
